// client/src/components/Footer.jsx
import React from "react";
import { NavLink } from "react-router-dom";

export default function Footer() {
  const wrap = {
    marginTop: 40,
    padding: "18px 12px 26px",
  };

  const panel = {
    maxWidth: 1120,
    margin: "0 auto",
    borderRadius: 18,
    padding: "14px 16px",
    border: "1px solid rgba(255,255,255,0.10)",
    background:
      "linear-gradient(180deg, rgba(88,88,88,0.40) 0%, rgba(20,20,20,0.68) 55%, rgba(10,10,10,0.78) 100%)",
    boxShadow: "0 18px 60px rgba(0,0,0,0.55)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
  };

  const linksRow = {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    alignItems: "center",
    justifyContent: "center",
  };

  const linkStyle = ({ isActive }) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 12px",
    borderRadius: 999,
    border: "1px solid rgba(255,255,255,0.14)",
    background: isActive ? "rgba(255, 40, 40, 0.20)" : "rgba(255,255,255,0.06)",
    color: "rgba(255,255,255,0.92)",
    fontWeight: 800,
    letterSpacing: 0.2,
  });

  const fine = {
    marginTop: 12,
    textAlign: "center",
    color: "rgba(255,255,255,0.70)",
    fontSize: 12,
    lineHeight: 1.35,
  };

  const year = new Date().getFullYear();

  return (
    <footer style={wrap}>
      <div style={panel}>
        <div style={linksRow}>
          <NavLink to="/about" style={linkStyle}>
            About
          </NavLink>
          <NavLink to="/privacy" style={linkStyle}>
            Privacy
          </NavLink>
          <NavLink to="/terms" style={linkStyle}>
            Terms
          </NavLink>
          <NavLink to="/community-guidelines" style={linkStyle}>
            Community Guidelines
          </NavLink>
          <NavLink to="/donate" style={linkStyle}>
            Donate
          </NavLink>
        </div>

        <div style={fine}>
          © {year} GAStreaming. All rights reserved.
          <br />
          This site may use third-party services for streaming, payments, and order fulfillment.
        </div>
      </div>
    </footer>
  );
}